/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Case,
  CaseOwnerResponse,
  CaseServiceDetailsResponse,
  CompatibilityCheckResult,
  DocumentDeliveryRequest,
  DocumentDeliveryResponse,
  DocumentOfferingRequest,
  ProductServiceDetailsResponse,
  ProductServiceResponse,
} from '../models/index';
import {
    CaseFromJSON,
    CaseToJSON,
    CaseOwnerResponseFromJSON,
    CaseOwnerResponseToJSON,
    CaseServiceDetailsResponseFromJSON,
    CaseServiceDetailsResponseToJSON,
    CompatibilityCheckResultFromJSON,
    CompatibilityCheckResultToJSON,
    DocumentDeliveryRequestFromJSON,
    DocumentDeliveryRequestToJSON,
    DocumentDeliveryResponseFromJSON,
    DocumentDeliveryResponseToJSON,
    DocumentOfferingRequestFromJSON,
    DocumentOfferingRequestToJSON,
    ProductServiceDetailsResponseFromJSON,
    ProductServiceDetailsResponseToJSON,
    ProductServiceResponseFromJSON,
    ProductServiceResponseToJSON,
} from '../models/index';

export interface CreateMandateRequest {
    accountNumber: string;
}

export interface DistributeCaseDocumentsRequest {
    caseId: number;
    documentDeliveryRequest: DocumentDeliveryRequest;
}

export interface GetAccountProductsAndServicesRequest {
    accountNumber: string;
}

export interface GetCaseOwnerRequest {
    caseId: number;
}

export interface GetCaseProductServiceRequest {
    caseId: number;
}

export interface GetProductServiceRequest {
    accountNumber: string;
    productServiceId: string;
}

export interface GetProspectProductsAndServicesRequest {
    partnerUid: string;
}

export interface SaveTemporaryCaseRequest {
    _case: Case;
}

export interface UpdateDocumentStatusRequest {
    documentOfferingRequest: DocumentOfferingRequest;
}

export interface UpdateOfferingsRequest {
    caseId: number;
}

/**
 * 
 */
export class ProductsAndServicesApi extends runtime.BaseAPI {

    /**
     * Creates request options for createMandate without sending the request
     */
    async createMandateRequestOpts(requestParameters: CreateMandateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accountNumber'] == null) {
            throw new runtime.RequiredError(
                'accountNumber',
                'Required parameter "accountNumber" was null or undefined when calling createMandate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/mandate/{accountNumber}/new`;
        urlPath = urlPath.replace(`{${"accountNumber"}}`, encodeURIComponent(String(requestParameters['accountNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Takes user to a new mandate form and performs product compatibility check
     * Takes use to a new mandate form
     */
    async createMandateRaw(requestParameters: CreateMandateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompatibilityCheckResult>> {
        const requestOptions = await this.createMandateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompatibilityCheckResultFromJSON(jsonValue));
    }

    /**
     * Takes user to a new mandate form and performs product compatibility check
     * Takes use to a new mandate form
     */
    async createMandate(requestParameters: CreateMandateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompatibilityCheckResult> {
        const response = await this.createMandateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for distributeCaseDocuments without sending the request
     */
    async distributeCaseDocumentsRequestOpts(requestParameters: DistributeCaseDocumentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling distributeCaseDocuments().'
            );
        }

        if (requestParameters['documentDeliveryRequest'] == null) {
            throw new runtime.RequiredError(
                'documentDeliveryRequest',
                'Required parameter "documentDeliveryRequest" was null or undefined when calling distributeCaseDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/productservices/case/{caseId}/distributeDocuments`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentDeliveryRequestToJSON(requestParameters['documentDeliveryRequest']),
        };
    }

    /**
     * Distribute documents related to Case
     * Distribute documents related to Case
     */
    async distributeCaseDocumentsRaw(requestParameters: DistributeCaseDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentDeliveryResponse>> {
        const requestOptions = await this.distributeCaseDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDeliveryResponseFromJSON(jsonValue));
    }

    /**
     * Distribute documents related to Case
     * Distribute documents related to Case
     */
    async distributeCaseDocuments(requestParameters: DistributeCaseDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentDeliveryResponse> {
        const response = await this.distributeCaseDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccountProductsAndServices without sending the request
     */
    async getAccountProductsAndServicesRequestOpts(requestParameters: GetAccountProductsAndServicesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accountNumber'] == null) {
            throw new runtime.RequiredError(
                'accountNumber',
                'Required parameter "accountNumber" was null or undefined when calling getAccountProductsAndServices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/account/{accountNumber}`;
        urlPath = urlPath.replace(`{${"accountNumber"}}`, encodeURIComponent(String(requestParameters['accountNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * gets the products and services information for a given eligible account
     * gets the products and services information for a given eligible account
     */
    async getAccountProductsAndServicesRaw(requestParameters: GetAccountProductsAndServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductServiceResponse>> {
        const requestOptions = await this.getAccountProductsAndServicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductServiceResponseFromJSON(jsonValue));
    }

    /**
     * gets the products and services information for a given eligible account
     * gets the products and services information for a given eligible account
     */
    async getAccountProductsAndServices(requestParameters: GetAccountProductsAndServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductServiceResponse> {
        const response = await this.getAccountProductsAndServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCaseOwner without sending the request
     */
    async getCaseOwnerRequestOpts(requestParameters: GetCaseOwnerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getCaseOwner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/case/{caseId}/owner`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * get the account or partner that owns the case given a caseId
     * get the account or partner that owns the case
     */
    async getCaseOwnerRaw(requestParameters: GetCaseOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseOwnerResponse>> {
        const requestOptions = await this.getCaseOwnerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseOwnerResponseFromJSON(jsonValue));
    }

    /**
     * get the account or partner that owns the case given a caseId
     * get the account or partner that owns the case
     */
    async getCaseOwner(requestParameters: GetCaseOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseOwnerResponse> {
        const response = await this.getCaseOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCaseProductService without sending the request
     */
    async getCaseProductServiceRequestOpts(requestParameters: GetCaseProductServiceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getCaseProductService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/case/{caseId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * gets the product and service information given a caseId
     * get the product and service information for the Case
     */
    async getCaseProductServiceRaw(requestParameters: GetCaseProductServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseServiceDetailsResponse>> {
        const requestOptions = await this.getCaseProductServiceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseServiceDetailsResponseFromJSON(jsonValue));
    }

    /**
     * gets the product and service information given a caseId
     * get the product and service information for the Case
     */
    async getCaseProductService(requestParameters: GetCaseProductServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseServiceDetailsResponse> {
        const response = await this.getCaseProductServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProductService without sending the request
     */
    async getProductServiceRequestOpts(requestParameters: GetProductServiceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accountNumber'] == null) {
            throw new runtime.RequiredError(
                'accountNumber',
                'Required parameter "accountNumber" was null or undefined when calling getProductService().'
            );
        }

        if (requestParameters['productServiceId'] == null) {
            throw new runtime.RequiredError(
                'productServiceId',
                'Required parameter "productServiceId" was null or undefined when calling getProductService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/account/{accountNumber}/product/{productServiceId}`;
        urlPath = urlPath.replace(`{${"accountNumber"}}`, encodeURIComponent(String(requestParameters['accountNumber'])));
        urlPath = urlPath.replace(`{${"productServiceId"}}`, encodeURIComponent(String(requestParameters['productServiceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * gets the product and service information given an accountNumber and a productServiceId
     * get the product and service information
     */
    async getProductServiceRaw(requestParameters: GetProductServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductServiceDetailsResponse>> {
        const requestOptions = await this.getProductServiceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductServiceDetailsResponseFromJSON(jsonValue));
    }

    /**
     * gets the product and service information given an accountNumber and a productServiceId
     * get the product and service information
     */
    async getProductService(requestParameters: GetProductServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductServiceDetailsResponse> {
        const response = await this.getProductServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProspectProductsAndServices without sending the request
     */
    async getProspectProductsAndServicesRequestOpts(requestParameters: GetProspectProductsAndServicesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling getProspectProductsAndServices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/partner/{partnerUid}`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * gets the products and services information for a given eligible partner
     * gets the products and services information for a given eligible partner
     */
    async getProspectProductsAndServicesRaw(requestParameters: GetProspectProductsAndServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductServiceResponse>> {
        const requestOptions = await this.getProspectProductsAndServicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductServiceResponseFromJSON(jsonValue));
    }

    /**
     * gets the products and services information for a given eligible partner
     * gets the products and services information for a given eligible partner
     */
    async getProspectProductsAndServices(requestParameters: GetProspectProductsAndServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductServiceResponse> {
        const response = await this.getProspectProductsAndServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveTemporaryCase without sending the request
     */
    async saveTemporaryCaseRequestOpts(requestParameters: SaveTemporaryCaseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['_case'] == null) {
            throw new runtime.RequiredError(
                '_case',
                'Required parameter "_case" was null or undefined when calling saveTemporaryCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/productservices/case/temporal`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CaseToJSON(requestParameters['_case']),
        };
    }

    /**
     * Store a new temporary case
     * Store a new temporary case
     */
    async saveTemporaryCaseRaw(requestParameters: SaveTemporaryCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Case>> {
        const requestOptions = await this.saveTemporaryCaseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFromJSON(jsonValue));
    }

    /**
     * Store a new temporary case
     * Store a new temporary case
     */
    async saveTemporaryCase(requestParameters: SaveTemporaryCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Case> {
        const response = await this.saveTemporaryCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDocumentStatus without sending the request
     */
    async updateDocumentStatusRequestOpts(requestParameters: UpdateDocumentStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['documentOfferingRequest'] == null) {
            throw new runtime.RequiredError(
                'documentOfferingRequest',
                'Required parameter "documentOfferingRequest" was null or undefined when calling updateDocumentStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/productservices/offerings/documents`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentOfferingRequestToJSON(requestParameters['documentOfferingRequest']),
        };
    }

    /**
     * updates Document Status from MSD in PCO
     * updates Document Status from MSD in PCO
     */
    async updateDocumentStatusRaw(requestParameters: UpdateDocumentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateDocumentStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * updates Document Status from MSD in PCO
     * updates Document Status from MSD in PCO
     */
    async updateDocumentStatus(requestParameters: UpdateDocumentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDocumentStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateOfferings without sending the request
     */
    async updateOfferingsRequestOpts(requestParameters: UpdateOfferingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateOfferings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/case/{caseId}/update`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * update the offerings from MSD given a caseId
     * update the offerings from MSD
     */
    async updateOfferingsRaw(requestParameters: UpdateOfferingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateOfferingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update the offerings from MSD given a caseId
     * update the offerings from MSD
     */
    async updateOfferings(requestParameters: UpdateOfferingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOfferingsRaw(requestParameters, initOverrides);
    }

}
